import { z } from 'zod';

/**
 * 連携設定タブの search。通常アクセスは空。
 * Admin Consent 完了後に BE が `result` / `softwareId` / `errorMessage` を付与する。
 */
export const IntegrationSettingsSearchSchema = z.object({
  /** Admin Consent callback 結果（BE リダイレクト時のみ） */
  result: z.enum(['success', 'error']).optional(),
  /** 成功時に BE が付与（params.id と一致確認用） */
  softwareId: z.string().optional(),
  /** 失敗時の表示文言（BE が locale 済みで付与） */
  errorMessage: z.string().optional().transform(s => s?.replaceAll('+', ' '))
});
export type IntegrationSettingsSearch = z.infer<typeof IntegrationSettingsSearchSchema>;